// extracted by mini-css-extract-plugin
module.exports = {"container":"ValidationMessage_container__2G5A3","error":"ValidationMessage_error__2Xv-i"};